import ComponentWithSocket from '../../../lib/component';
import CKEditor from 'ckeditor4-vue';
import { Component } from 'vue-property-decorator';

@Component({
    components: { ckeditor: CKEditor.component },
})
export default class BlogAdd extends ComponentWithSocket {
    private readonly token = 'c8f02a40c3fa8e6383228cc95242aac3';

    public article: {
        title: string;
        slug: string;
        excerpt: string;
        content: string;
        featuredImageAlt: string;
        metaTitle: string;
        metaDescription: string;
        status: number;
    } = {
        title: '',
        slug: '',
        excerpt: '',
        content: '',
        featuredImageAlt: '',
        metaTitle: '',
        metaDescription: '',
        status: 0,
    };

    public featuredImageFile: any = undefined;
    public slugManuallyEdited: boolean = false;

    public addBtnLoading: boolean = false;
    public addArticleSuccess: string = '';
    public addArticleError: string = '';

    public statusOptions = [
        { value: 0, text: 'Draft' },
        { value: 1, text: 'Publicat' },
    ];

    public ckeditorConfig: any = {
        entities_latin: false,
        basicEntities: false,
        language: 'ro',
    };

    constructor() {
        super();
    }

    onTitleInput() {
        if (!this.slugManuallyEdited) {
            this.article.slug = this.slugify(this.article.title);
        }
    }

    onSlugInput() {
        this.slugManuallyEdited = true;
    }

    regenerateSlug() {
        this.slugManuallyEdited = false;
        this.article.slug = this.slugify(this.article.title);
    }

    private slugify(value: string): string {
        return value
            .toLowerCase()
            .normalize('NFD').replace(/[̀-ͯ]/g, '')
            .replace(/[^a-z0-9\s-]/g, '')
            .trim()
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-');
    }

    async addArticleAction() {
        if (!this.article.title || !this.article.slug) {
            alert('Te rugam sa completezi titlul si slug-ul');
            return;
        }

        // tslint:disable:no-null-keyword — null is sent intentionally so the API clears empty fields
        const payload: any = {
            title: this.article.title,
            slug: this.article.slug,
            excerpt: this.article.excerpt || null,
            content: this.article.content || null,
            featuredImageAlt: this.article.featuredImageAlt || null,
            metaTitle: this.article.metaTitle || null,
            metaDescription: this.article.metaDescription || null,
            status: this.article.status,
        };
        // tslint:enable:no-null-keyword

        if (this.featuredImageFile) {
            payload.featuredImage = await this.convertToBase64(this.featuredImageFile);
        }

        this.addBtnLoading = true;

        await fetch(`${process.env.API2_URL}/article?token=${this.token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(response => {
            return response.json().then(data => ({ ok: response.ok, status: response.status, data }));
        }).then(({ ok, data }) => {
            this.addBtnLoading = false;

            if (ok && data && data.success) {
                this.addArticleSuccess = data.message;
                this.addArticleError = '';
                this.$router.push('/blog');
            } else {
                this.addArticleError = (data && data.message) || 'Eroare la salvare';
                this.addArticleSuccess = '';
            }
        }).catch(error => {
            console.error('Error:', error);
            this.addArticleError = String(error);
            this.addArticleSuccess = '';
            this.addBtnLoading = false;
        });
    }

    convertToBase64(image: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                if (!e.target) {
                    reject(new Error('No target'));
                    return;
                }

                resolve(e.target.result);
            };

            reader.onerror = error => {
                reject(error);
            };

            reader.readAsDataURL(image);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/blog/add/index.ts